<script lang="ts">
	import { formatNoteDate, type LatestNote } from '$lib/latest-note';
	import type { SiteConfig } from '$lib/types';

	interface Props {
		site: SiteConfig;
		latestNote?: LatestNote | null;
	}

	let { site, latestNote = null }: Props = $props();
</script>

<section id="notes" class="section notes" aria-labelledby="notes-heading">
	<div class="container notes-grid">
		<div class="section-intro">
			<p class="eyebrow">Journal</p>
			<h2 id="notes-heading">{site.home.cta.title}</h2>
			<div class="section-rule" aria-hidden="true"></div>
		</div>

		<div class="notes-body">
			<p>{site.home.cta.body}</p>

			{#if latestNote}
				<a class="latest-note" href="{site.urls.blog}/posts/{latestNote.slug}">
					<span class="latest-label">Latest</span>
					<span class="latest-title">{latestNote.title}</span>
					<span class="latest-meta">
						{#if latestNote.date}
							<time datetime={latestNote.date}>{formatNoteDate(latestNote.date)}</time>
							<span aria-hidden="true">·</span>
						{/if}
						Continue reading
						<span aria-hidden="true">→</span>
					</span>
				</a>
			{/if}

			<a class="button button-primary" href={site.urls.blog}>Read the notes</a>
		</div>
	</div>
</section>
